export default [
  '#FCB900',
  '#0693E3',
  '#FF6900',
  '#00D084',
  '#EB144C',
  '#8ED1FC',
  '#7BDCB5',
  '#F78DA7',
  '#ABB8C3',
  '#9900EF'
]
